import * as React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// enable dark mode
const enableDarkmode = () => {
  document.body.classList.add("darkmode");
  localStorage.setItem("darkmode", "active");
};

//  disable dark mode
const disableDarkmode = () => {
  document.body.classList.remove("darkmode");
  localStorage.setItem("darkmode", "");
};


let darkmode = localStorage.getItem("darkmode");
if (darkmode === "active") {
  enableDarkmode();
}


const themeSwitch = document.getElementById("theme-switch");
if (themeSwitch) {
  themeSwitch.addEventListener("click", () => {
    darkmode = localStorage.getItem("darkmode");
    darkmode !== "active" ? enableDarkmode() : disableDarkmode();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
